import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <ul className="social-list">
        <li className="social-list__item">
          <a
            href="mailto:ttdd273w@gmail.com"
            className="social-list__link"
            aria-label="Email Tony"
          >
            <i className="fa fa-envelope" aria-hidden="true"></i>
          </a>
        </li>
        <li className="social-list__item">
          <a
            href="https://github.com/ttdd273"
            className="social-list__link"
            aria-label="Tony's GitHub"
          >
            <i className="fa fa-github" aria-hidden="true"></i>
          </a>
        </li>
        <li className="social-list__item">
          <a
            href="https://www.linkedin.com/in/ttdd273w"
            className="social-list__link"
            aria-label="Tony's LinkedIn"
          >
            <i className="fa fa-linkedin" aria-hidden="true"></i>
          </a>
        </li>
      </ul>
    </footer>
  );
}

export default Footer;
